import React from 'react';

import {
  ActionButton,
  Actions,
  CardDescription,
  CardRoot,
  CardTitle,
  Content,
  Extra,
  IconCircle,
  InlineLink,
  MainRow,
  TextBlock,
} from './styles';

export type PendencyActionVariant = 'primary' | 'secondary';

export type PendencyAction = {
  label: string;
  onClick: () => void;
  variant?: PendencyActionVariant;
  disabled?: boolean;
};

export interface PendencyCardProps {
  icon?: React.ReactNode;
  title: string;
  description: React.ReactNode;
  actions?: PendencyAction[];
  children?: React.ReactNode;
  className?: string | undefined;
}

export const PendencyCardLink = ({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick: () => void;
}): JSX.Element => (
  <InlineLink type="button" onClick={onClick}>
    {children}
  </InlineLink>
);

const PendencyCard = ({
  icon,
  title,
  description,
  actions,
  children,
  className,
}: PendencyCardProps): JSX.Element => {
  return (
    <CardRoot className={className}>
      <MainRow>
        <Content>
          {icon && <IconCircle aria-hidden="true">{icon}</IconCircle>}
          <TextBlock>
            <CardTitle>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </TextBlock>
        </Content>

        {actions && actions.length > 0 && (
          <Actions>
            {actions.map((action) => (
              <ActionButton
                key={action.label}
                type="button"
                $variant={action.variant ?? 'primary'}
                disabled={action.disabled}
                onClick={action.onClick}
              >
                {action.label}
              </ActionButton>
            ))}
          </Actions>
        )}
      </MainRow>

      {children && <Extra>{children}</Extra>}
    </CardRoot>
  );
};

export default PendencyCard;
